import { FileText, Star } from 'lucide-react';

// ===============================================
// DOCUMENT TYPES AND CATEGORIES - محدّث
// ===============================================

export const getDocumentTypes = (t) => [{
      id: "hr_letter",
      name: t.hrLetter,
      icon: FileText,
      description: t.hrLetterDesc,
    },
    {
      id: "bank_hr_letter",
      name: t.bankHRLetter,
      icon: FileText,
      description: t.bankHRLetterDesc,
    },
    {
      id: "experience_certificate",
      name: t.experienceCertificate,
      icon: Star,
      description: t.experienceCertificateDesc,
    },
  ];
